import { Component } from "react";
import { ReactToMarionetteView } from "extensions/marionette";
import { Tabs } from "common/components/tabs/reactTabs";
import { references } from "common/helpers/references";

import { ErrorView } from "common/components/error";
import { NoDataAvailable } from "common/helpers/errors";

import { TrendlineTabBody } from "./trendlineTabBody";

export class TrendlineBodyContents extends Component {
    getTabs() {
        const tabData = this.sortAndGetTotals(this.props);
        const pivotKey = this.props.first_pivot_key;
        const reactProps = this.props.subModel.get("trendline").reactProps;
        const getBadge = (tab) => (reactProps.showBadgeInTabs ? `${references.toAlias(tab.name, pivotKey)}<span class='badge'>${tab.count}</span>` : `${references.toAlias(tab.name, pivotKey)}`);
        
        const parentPropsToPass = {
            dateRanges: this.props.dateRanges,
            first_pivot_key: this.props.first_pivot_key,
            widgetContainer: this.props.widgetContainer,
            widgetType: this.props.widgetType,
            widgetSubType: this.props.widgetSubType,
            widgetQualifiers: this.props.widgetQualifiers,
            subModel: this.props.subModel
        };
        
        return tabData.map((tab, i) => (
            {
                name: getBadge(tab),
                view: ReactToMarionetteView.extend({
                    className: `center-loader ${reactProps.bodyClass}`,
                    component: <TrendlineTabBody {...parentPropsToPass} pivotName={tab.name} data={tabData} />
                }),
                viewOptions: {
                    pivot: tab.name
                },
                active: i === 0,
                newTab: true,
                hideTooltip: true,
                hideCloseIcon: true
            }
        ));
    }
    
    sortAndGetTotals() {
        const props = this.props;
        const tabPivot = props.first_pivot_key;
        const subType = props.subModel.get("trendline");
        const topField = subType.reactProps.countField;
        const bottomField = subType.reactProps.otherCountField;
        const sorted = props.data.map((item) => ({
            tabPivot, topField, bottomField, name: item[tabPivot], topCount: Math.abs(item[topField]), bottomCount: Math.abs(item[bottomField]), ...item
        })).sort((a, b) => (a.topCount < b.topCount ? 1 : -1));
        return sorted;
    }
    
    render() {
        if (this.props.data.length === 0) {
            return (
                <ErrorView
                    captureInSentry={false}
                    error={new NoDataAvailable({
                        custom: true,
                        header: "No data available",
                        message: "Try expanding your date range or removing any applied filters.",
                        actions: false,
                        hideDetails: true
                    })}
                />
            );
        }
        
        return (
            <Tabs eventHandler={this.tabsEventsHandler} name="widget-tabs" newTabButton={false} stickyNav={false} persist={false} theme="style-1 style-3 react-widget">
                {this.getTabs()}
            </Tabs>
        );
    }
}
